import { CheckToken } from "../login/AccessToken";
import React, { useEffect, useState } from "react";
import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import HTMateIcon from "../../assets/images/gallery/B-T-HTMATE.svg";
import HTBridgeIcon from "../../assets/images/gallery/B-T-BRIDGE.svg";
import HTHrpIcon from "../../assets/images/gallery/B-T-HTHRP.svg";
import { accessMapping, arr } from "../hlthtek-demo/constants";

const LandingPage = ({ setBrandingData }) => {
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") || ""
  );
  const [title, setTitle] = useState("");
  const [dataLoaded, setDataLoaded] = useState(false);
  const [filteredItems, setFilteredItems] = useState([]);
  const [userRole, setUserRole] = useState(sessionStorage.getItem("roleType"));
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const Token = () => {
    const check = CheckToken();
    console.log(check);
    setAuthToken(sessionStorage.getItem("accessToken"));
    return check;
  };
  const history = useHistory();
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  const navigate = (route) => {
    console.log(route);
    history.push(`/${route}`);
  };
  const fetchBrandingData = () => {
    const payload = {
      // functionality: "branding",
      // segment: "images",
      // config_type:"configuration",
      bucket_type: "license",
      bucket_category: "conf",
      file_key: "",
      facility: false,
    };

    axios
      .post(`${REACT_APP_BACKEND_ROUTE_URL}get_facility_branding/`, payload, {
        headers,
      })
      .then((res) => {
        if (res.data.status === "Success") {
          setBrandingData(res.data?.data);
          console.log("branding..demo", res.data?.data);
        } else if (res?.data?.message === "No files found.") {
          toast.info("Branding information not yet provided");
        } else {
          // toast.error("Error fetching branding data");
          console.log("Error:", res.data.message);
        }
      })
      .catch((err) => {
        console.log("Error fetching branding data:", err);
        toast.error("Error fetching branding data");
      });
  };

  useEffect(() => {
    if (authToken && userRole) {
      fetchBrandingData();
    }
  }, []);
  useEffect(() => {
    if (Token()) {
      axios
        .get(`${REACT_APP_BACKEND_ROUTE_URL}get_logged_in_user_info/`, {
          headers: headers,
        })
        .then((res) => {
          if (res.data.status === "Success") {
            console.log("data", res.data);
            setTitle(res.data.facility_name);
            sessionStorage.setItem(
              "isAbdmEnabled",
              res.data.abdm_enabled || false
            );
            sessionStorage.setItem(
              "isEmailEnabled",
              res.data.email_enabled || false
            );
            sessionStorage.setItem("isAiEnabled", res.data.ai_enabled || false);
            const {
              facility_address_line_1,
              facility_address_line_2,
              facility_address_line_3,
            } = res.data;

            const addressLines = {
              facilityAddressLine1: facility_address_line_1,
              facilityAddressLine2: facility_address_line_2,
              facilityAddressLine3: facility_address_line_3,
            };

            Object.entries(addressLines).forEach(([key, value]) =>
              sessionStorage.setItem(key, value ?? "")
            );

            sessionStorage.setItem("doctor_id", res.data.doctor_id || "");
            let allowedPaths = [];
            if (userRole === "doctor") {
              allowedPaths = accessMapping[userRole];
            }
            console.log("Allowed Paths", allowedPaths);
            // Filter the menu items based on the allowed paths
            const items = arr.filter((item) => allowedPaths.includes(item.id));
            console.log("Items", items);
            setFilteredItems(items);
            setDataLoaded(true);
            sessionStorage.setItem(
              "facility_display_name",
              res.data.facility_name
            );
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, []);

  return (
    <>
      <Grid container spacing={2} alignItems="center" justifyContent="center">
        {/* Title */}
        <Grid item xs={12}>
          <Typography variant="h3" textAlign="center">
            {title}
          </Typography>
        </Grid>
        <Grid
          item
          xs={4}
          container
          direction="column"
          justifyContent="left"
          // spacing={3}
          alignItems="center"
          sx={{ paddingLeft: { xs: "0.5rem", sm: "1rem" } }} // Adjust padding for responsiveness
        >
          <Grid item>
            <Box
              component="img"
              src={
                sessionStorage.getItem("subscriptionType") ===
                  "EHR/HMIS Service With ABDM Connector - HIU/HIP" ||
                sessionStorage.getItem("subscriptionType") ===
                  "EHR/HMIS Service Without ABDM Connector"
                  ? HTMateIcon
                  : sessionStorage.getItem("subscriptionType") ===
                      "ABDM Connector/Adaptor - HIU/HIP" ||
                    sessionStorage.getItem("subscriptionType") ===
                      "ABDM Connector/Adaptor - HIU" ||
                    sessionStorage.getItem("subscriptionType") ===
                      "ABDM Connector/Adaptor - HIP"
                  ? HTBridgeIcon
                  : HTHrpIcon
              }
              alt="HT Mate Icon"
              sx={{
                borderRadius: "5px",
                // width: { xs: 50, sm: 60, md: 80, lg: 100 }, // Responsive width
                height: { xs: 50, sm: 60, md: 80, lg: 100 }, // Responsive height
                width: { xs: 150, sm: 210, md: 255, lg: 300 }, // Responsive width
              }}
            />
          </Grid>

          {/* <Grid item>
            <Typography variant="body1" fontSize="1rem" color="black">
              <b>
                {sessionStorage.getItem("subscriptionType") ===
                  "EHR/HMIS Service With ABDM Connector - HIU/HIP" ||
                sessionStorage.getItem("subscriptionType") ===
                  "EHR/HMIS Service Without ABDM Connector"
                  ? "HTMATE"
                  : sessionStorage.getItem("subscriptionType") ===
                      "ABDM Connector/Adaptor - HIU/HIP" ||
                    sessionStorage.getItem("subscriptionType") ===
                      "ABDM Connector/Adaptor - HIU" ||
                    sessionStorage.getItem("subscriptionType") ===
                      "ABDM Connector/Adaptor - HIP"
                  ? "HTBRIDGE"
                  : "HTHRP"}
              </b>
            </Typography>
          </Grid> */}
        </Grid>
        <Grid
          item
          xs={8}
          container
          direction="column"
          justifyContent="flex-end"
          alignItems="flex-end"
          sx={{ paddingRight: { xs: "1rem", sm: "2rem" } }} // Adjust padding for responsiveness
        >
          {/* <Grid item>
            <Typography variant="body1" fontSize="1rem" color="black">
              <b>Dr Name : {sessionStorage.getItem("name")}</b>
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant="body1" fontSize="1rem" color="black" mt={1}>
              <b>Facility Name: {title}</b>
            </Typography>
          </Grid> */}
          {/* <Grid item>
            <Typography variant="body1" fontSize="1rem" color="black">
              <b>
                Subscription Type: {sessionStorage.getItem("subscriptionType")}
              </b>
            </Typography>
          </Grid> */}
        </Grid>
      </Grid>
      {dataLoaded && filteredItems.length > 0 ? (
        <Grid
          container
          spacing={3}
          sx={{
            p: { xs: 1, sm: 2, md: 3 }, // Responsive padding left/right
            width: "80%",
            margin: "20px auto",
            justifyContent: "center", // Center the grid container
            boxShadow: 3, // Add a shadow for card styling
            borderRadius: 2, // Rounded corners
          }}
        >
          {filteredItems.map((item) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              lg={3}
              key={item.id}
              onClick={() => navigate(item.path)}
              sx={{
                padding: "24px",
                cursor: "pointer", // Cursor pointer for click action
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Card
                sx={{
                  width: "80%",
                  height: { xs: "170px", sm: "180px" }, // Set a fixed height for uniformity
                  display: "flex",
                  justifyContent: "center",
                  boxShadow: 3, // Add a shadow for card styling
                  borderRadius: 2, // Rounded corners
                  transition: "transform 0.3s ease", // Smooth hover effect
                  backgroundColor: "#21cdc0",
                  padding: 2,
                  "&:hover": {
                    transform: "scale(1.05)",
                    backgroundColor: "#003366", // Slight zoom on hover
                  },
                }}
              >
                <CardContent
                  sx={{
                    textAlign: "center", // Center the content inside the card
                  }}
                >
                  <div
                    style={{
                      marginBottom: "2rem",
                    }}
                  >
                    {item.icon}
                  </div>

                  <Typography
                    variant="h6"
                    sx={{ color: "white", textAlign: "center" }}
                  >
                    {item.name}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      ) : (
        <Typography variant="h3" textAlign="center">
          No Entitlement
        </Typography>
      )}
    </>
  );
};

export default LandingPage;
